module.exports = __webpack_public_path__ + "static/media/mn.b6529a3b.svg";